import { get, put, post, remove, download } from './api.service'

const service = {
	getTeamFormation(challengeSpaceId: string, teamFormationId: string) {
		return get(
			// `/team-formations/${teamFormationId}/distributions/${distributionId}?include=distribution`
			`/challenge-spaces/${challengeSpaceId}/team-formations/${teamFormationId}?include=distribution`
		)
	},
	getTeamFormationDistribution(
		teamFormationId: string,
		teamDistributionId: string
	) {
		return get(
			`/team-formations/${teamFormationId}/distributions/${teamDistributionId}?include=challenges.company,challenges.organisation`
		)
	},
	updateTeamFormationDistribution(
		teamFormationId: string,
		distributionId: string,
		params: any
	) {
		return put(
			`/team-formations/${teamFormationId}/distributions/${distributionId}?include=distribution.challenges.company,distribution.challenges.organisation`,
			params
		)
	},
	postTeamFormationDistribution(teamFormationId: string) {
		return post(
			`/team-formations/${teamFormationId}/distributions?include=userProfilesInTeam`
		)
	},
	postTeamFormationInfo(teamFormationId: string, params = {}) {
		return post(
			`/team-formations/${teamFormationId}/info?include=userProfilesFiltered,userProfilesFilteredInTeam`,
			params
		)
	},
	createTeamFormationUser(
		teamFormationId: string,
		code: string,
		params: any,
		config?: any
	) {
		return post(
			`/team-formations/${teamFormationId}/team-formation-user?code=${code}`,
			params,
			config
		)
	},
	finalizeTeamFormation(teamFormationId: string, params = {}) {
		return put(`/team-formations/${teamFormationId}/finalize`, params)
	},
	getTeamFormationQuestion(teamFormationId: string, questionId: string) {
		return get(`/team-formations/${teamFormationId}/questions/${questionId}`)
	},
	putTeamFormationQuestion(
		teamFormationId: string,
		questionId: string,
		params: any
	) {
		return put(
			`/team-formations/${teamFormationId}/questions/${questionId}`,
			params
		)
	},
	deleteTeamFormationQuestion(teamFormationId: string, questionId: string) {
		return remove(`/team-formations/${teamFormationId}/questions/${questionId}`)
	},
	getTeamFormationDefaultQuestions() {
		return get(`/team-formations/default-questions`)
	},
	createTeamFormationQuestion(teamFormationId: string, params: any) {
		return post(`/team-formations/${teamFormationId}/questions`, params)
	},
	getMappedProfiles(
		questions: any[] = [],
		profiles: any[] = [],
		answers: any[] = [],
		challenges: {} = {},
		users: any[] = []
	) {
		let mappedProfiles = Object.values(profiles).map((profile: any) => {
			return {
				...profile,
				questionsWithAnswers: profile.relationships.answers
					? profile.relationships.answers.data
							.map((currentAnswerId) => {
								//Deep cloning an object
								//Using a simple ... spread causes issues with nested property references and modifies these properties
								const answerObject = {
									...JSON.parse(JSON.stringify(answers[currentAnswerId.id])),
								}
								let answer = answerObject.attributes.answer
									? answerObject.attributes.answer
									: 'Answer Missing'

								const regex_idCheck = new RegExp('(\\w+(-)){4}(\\w+)', 'g')
								const isAnswerAnId =
									typeof answer === 'string' && regex_idCheck.test(answer)
								const isAnswerAnArray = Array.isArray(answer)

								if (isAnswerAnId) {
									//If current answer is an ID, find it options of a question
									const isInOptions = questions.find((currentQuestion) => {
										return (
											currentQuestion.id ===
												answerObject?.relationships?.question?.data?.id &&
											currentQuestion?.options?.items?.find(
												(option) => option.id === answer
											)
										)
									})
									if (isInOptions) {
										//If answer was found in options of a question assign it to answer
										answer = isInOptions.options.items.find(
											(option) => option.id === answer
										)
									}
								} else if (isAnswerAnArray) {
									// if answer is an array, find it in options based on different parameters than previous if statement
									const multipleAnswers = [...answer]

									answer = multipleAnswers.map((currentAnswerId) => {
										//TemporaryAnswer, nested in the map
										let temporaryAnswer = currentAnswerId

										const isInOptions = questions.find((currentQuestion) => {
											return (
												currentQuestion.id ===
													answerObject?.relationships?.question?.data?.id &&
												currentQuestion?.options?.items?.find((option) => {
													return (
														option.id === currentAnswerId ||
														option.value === currentAnswerId ||
														option === currentAnswerId
													)
												})
											)
										})

										if (isInOptions) {
											//If answer is found in general in options of a question
											temporaryAnswer = isInOptions?.options?.items?.find(
												(option) => {
													// different parameters than previous (typeOf id) if statement
													return (
														option.id === currentAnswerId ||
														option.value === currentAnswerId ||
														option === currentAnswerId
													)
												}
											)
										} else {
											//If answer is still not found then it must be a challenge id so find it in list of challenges
											temporaryAnswer =
												challenges &&
												Object.values(challenges).find(
													(option: any) => option.id === currentAnswerId
												)
										}

										//Return temporaryAnswer from map and assign it to answer variable
										return temporaryAnswer
									})
								}
								answerObject.attributes.answer = answer

								return {
									answer: answerObject,
									question: answerObject.relationships.question.data !==
										null && {
										...questions.find(
											(currentQuestion) =>
												currentQuestion.id ===
												answerObject.relationships.question.data.id
										),
									},
								}
							})
							.sort((a, b) => {
								return a.question.listPosition - b.question.listPosition
							})
					: [],
				profileData: {
					...users[profile?.relationships?.user?.data?.id],
				},
			}
		})
		return mappedProfiles
	},
	deleteTeamFromTeamFormation(teamFormationId, distributionId, teamId) {
		return remove(
			`/team-formations/${teamFormationId}/distributions/${distributionId}/teams/${teamId}`
		)
	},
	exportTeamFormationInfo(
		params: { teamFormationId: string },
		filetype: string
	) {
		return download(
			`/team-formations/${params.teamFormationId}/export/${filetype}`,
			null,
			{
				authenticate: true,
				contentType: 'text/${filetype}',
			}
		)
	},
	getTeamFormationTeamRequirements(teamFormationId: string, options?) {
		return get(
			`/team-formations/${teamFormationId}/team-requirements`,
			null,
			options
		)
	},
	createTeamRequirements(teamFormationId: string, params: any) {
		return post(`/team-formations/${teamFormationId}/team-requirements`, params)
	},
	updateTeamRequirement(
		teamFormationId: string,
		teamRequirementId: string,
		params
	) {
		return put(
			`/team-formations/${teamFormationId}/team-requirements/${teamRequirementId}`,
			params
		)
	},
	removeTeamRequirement(teamFormationId: string, teamRequirementId: string) {
		return remove(
			`/team-formations/${teamFormationId}/team-requirements/${teamRequirementId}`
		)
	},
}
export default service

export const mapTeamFormationFiltersToParams = (filters) => {
	let arr = []
	filters.forEach((filter) => {
		if (filter?.teamFormationQuestionAnswerIds?.length > 0) {
			arr.push({
				teamFormationQuestionId: filter.teamFormationQuestionId,
				teamFormationQuestionAnswerIds: filter.teamFormationQuestionAnswerIds,
			})
		}
	})
	return arr
}
